import { PostStatus } from '../data-layer/posts/constants';
import { EventSource } from './analyticsService';

enum Goals {
    ANY_LIKE = 'any_like',
    ANY_DISLIKE = 'any_dislike',
    ANY_FAVOURITE = 'any_favourite',
    ANY_SUBSCRIBE = 'any_subscribe',
    ANY_CLICKOUT = 'any_clickout',
    ANY_POST_SHARE = 'any_post_share',
    ANY_DESCRIPTION_OPEN = 'any_description_open',
    REGISTRATION_WANTED = 'registration_wanted',
    OFFER_ACCEPTED = 'oferta_accepted',
    CHANGE_COVER = 'cover_change',
    SAVE_COVER = 'cover_save',
    COVER_CHANGE_ERROR = 'cover_error',
    CHANGE_AVATAR = 'profile_picture_change',
    SAVE_AVATAR = 'profile_picture_save',
    AVATAR_CHANGE_ERROR = 'profile_picture_error',
    GO_TO_SETTINGS = 'settings',
    PUBLISHED_TAB_CLICK = 'tab_published',
    ALL_POST_TAB_CLICK = 'tab_all_posts',
    REGISTRATION_SITE_FILLED = 'registration_link',
    REGISTRATION_INSTAGRAM_FILLED = 'registration_instagram',
    REGISTRATION_TELEGRAM_FILLED = 'registration_telegram',
    REGISTRATION_BUSINESS_NAME_FILLED = 'registration_business_name',
    REGISTRATION_OFFER_CHECKED = 'registration_oferta',
    REGISTRATION_AGREED_LETTERS_CHECKED = 'registration_no_marketingletters',
    SUBMIT_REGISTRATION = 'registration_go_to_beta',
    PROFILE_POST_CLICK = 'profile_post_click',
    CHAT = 'chat',
    STATISTIC_CLICK = 'statistics_click',
    POST_KEBAB_CLICK = 'post_tochki',
    POST_EDIT_CLICK = 'post_editing',
    POST_DELETE_CLICK = 'post_delete',
    GO_TO_SUPPORT = 'support',
    SETTINGS_NAME_FILLED = 'name_change',
    SETTINGS_DESCRIPTION_FILLED = 'description_change',
    SETTINGS_SITE_FILLED = 'site_change',
    SETTINGS_HIDE_PROFILE = 'hide_profile',
    SETTINGS_IMPORT_PUBLISHED = 'download_and_publish',
    SETTINGS_IMPORT_DRAFT = 'download_and_draft',
    SETTINGS_DO_NOT_IMPORT = 'do_not_download',
    SETTINGS_REMOVE_USER = 'user_delete',
    SETTINGS_CREATE_INVITE = 'invite_create',
    SETTINGS_COPY_INVITE = 'invite_copy_link',
    SETTINGS_SAVE = 'profile_save',
    SETTINGS_REMOVE_BUSINESS = 'profile_delete',
    EDIT_POST_DESCRIPTION_FILLED = 'post_description',
    EDIT_POST_LINK_FILLED = 'post_link',
    EDIT_POST_DELETE = 'post_delete',
    EDIT_POST_REPUBLISH = 'post_republish',
    EDIT_POST_SAVE_DRAFT = 'post_draft_save',
    EDIT_POST_GET_DRAFT = 'post_get_draft',
    EDIT_POST_PREVIEW = 'post_preview',
    FEED_MANAGER = 'management',
    FEED_MANAGER_STATUS = 'management_status',
    FEED_MANAGER_SOURCE = 'management_source',
    FEED_MANAGER_PERIOD = 'management_period',
    FEED_MANAGER_SELECT_POST = 'management_post_select',
    FEED_MANAGER_DELETE_POST = 'management_post_delete',
    FEED_MANAGER_PUBLISH_POST = 'management_post_publish',
    FEED_MANAGER_STATISTIC = 'management_statistics_overview',
    FEED_MANAGER_POSTS = 'management_posts_overview',
    SEARCH_OPEN = 'search_open',
    SEARCH_INPUT_FOCUS_OUT = 'search_input_focus_out',
    SWITCH_SEARCH_TYPE = 'switch_search_type',
    SEARCH_GO_TO_POST = 'search_go_to_post',
    SEARCH_GO_TO_BUSINESS = 'search_go_to_business',
    SWITCH_PRODUCTS_AUTO_IMPORT = 'switch_products_auto_import',
    SWITCH_PRODUCTS_AUTO_PARSER = 'switch_products_auto_parser',
    REMOVE_PRODUCT_FROM_POST = 'remove_product_from_post',
    PRODUCTS_UNROLL = 'products_unroll',
    PRODUCT_CLICK_OUT = 'product_click_out',
    MORE_PRODUCTS_CLICK_OUT = 'more_products_click_out',
    PRODUCT_NOT_FOUND = 'product_not_found',
    FEED_SCROLL = 'feed_scroll',
    SEARCH_INPUT_START = 'search_input_start',
    OPEN_COLLECTION_LINK = 'open_collection_link',
    OPEN_COLLECTION_FROM_PROFILE = 'open_collection_from_profile',
    COLLECTION_LIKE = 'collection_like',
    COLLECTION_SHARED = 'collection_shared',
    COLLECTION_EDIT = 'collection_edit',
    COLLECTION_REPORT = 'collection_report',
    CONTEXT_MENU_OPEN = 'context_menu_open',
    COLLECTION_GET_PRODUCT_FROM_URL_OPEN_DIALOG = 'collection_get_product_from_url_open_dialog',
    COLLECTION_GET_PRODUCT_FROM_URL_CLOSE_DIALOG = 'collection_get_product_from_url_close_dialog',
    COLLECTION_GET_PRODUCT_FROM_URL_SUBMIT = 'collection_get_product_from_url_submit',
    COLLECTION_GET_PRODUCT_FROM_URL_ERROR = 'collection_get_product_from_url_error',
    COLLECTION_ADD_PRODUCT_POST_CLOSE_DIALOG = 'collection_add_product_post_close_dialog',
    COLLECTION_ADD_PRODUCT_POST_SUBMIT = 'collection_add_product_post_submit',
    COLLECTION_ADD_PRODUCT_POST_REMOVE_IMAGE = 'collection_add_product_post_remove_image',
    POST_STATUS_CLICK = 'post_status_click',
    SERVICE_RULES_LINK_CLICK = 'service_rules_link_click',
    SUPPORT_LINK_CLICK = 'support_link_click',
    SAW_FIFTH_POST = 'saw_fifth_post',
    SAW_TENTH_POST = 'saw_tenth_post',
    SAW_FIFTEENTH_POST = 'saw_fifteenth_post',
    CLICK_TO_INSTALL = 'web_click_to_install',
    POST_IN_GRID_CLICK = 'post_in_grid_click',
    BUSINESS_CATALOG_CLICK = 'business_catalog_click',
    PRODUCTS_CATALOG_CLICK = 'products_catalog_click',
    POST_CATALOG_CLICK = 'post_catalog_click',
    PRODUCT_IN_CATALOG_CLICKOUT = 'product_in_catalog_clickout',
    PRODUCT_CATALOG_CLICKOUT = 'product_catalog_clickout',
    POST_IN_GRID_ROW_SHOWN = 'grid_feed_post_shown',
    POST_IN_GRID_FEED_SCROLL = 'grid_feed_scroll',
    POST_IN_GRID_BUSINESS_CLICK = 'grid_feed_business_click',
    POST_IN_GRID_KEBAB_CLICK = 'grid_feed_kebab_click',
    POST_IN_GRID_KEBAB_SHARE = 'grid_feed_kebab_share',
    POST_IN_GRID_KEBAB_BUSINESS_CLICK = 'grid_feed_kebab_business_click',
    POST_IN_GRID_KEBAB_REPORT = 'grid_feed_kebab_complaint',
    POST_IN_GRID_VIDEO_PLAY = 'grid_feed_video_play',
    // события для товарной страницы в ПП
    FEED_CURTAIN_SHOWN = 'feed_curtain_shown',
    FEED_CURTAIN_PRODUCT_SHOWN = 'feed_curtain_product_shown',
    FEED_CURTAIN_PRODUCT_CLICK = 'feed_curtain_product_click',
    FEED_CURTAIN_BUTTON_SHOWN = 'feed_curtain_button_shown',
    FEED_CURTAIN_BUTTON_CLICK = 'feed_curtain_button_click',
}

const pages: Record<EventSource, string> = {
    [EventSource.BUSINESS]: 'Профиль бизнеса',
    [EventSource.WIDGET]: 'Погодный виджет',
    [EventSource.XIAOMI_WIDGET]: 'Погодный виджет',
    [EventSource.PROFILE]: 'Профиль',
    [EventSource.SEARCH]: 'Поиск',
    [EventSource.POST]: 'Пост',
    [EventSource.COLLECTION]: 'Коллекция',
    [EventSource.PRODUCTS]: 'Продукты',
    [EventSource.MULTICOLUMN]: 'Многоколоночный фид',
    [EventSource.PARTNER_REGISTRATION]: 'Регистрация партнеров',
    [EventSource.SEARCH_APP_FULLSCREEN]: 'Товары в посте',
};

export const getPageNameByEventSource = (eventSource: EventSource): string => pages[eventSource];

interface GoalInformation {
    userLogin?: string;
    businessId?: string;
    postId?: string;
    collectionId?: string;
    page?: string;
    value?: string;
    isPublic?: boolean;
    own?: boolean;
    reason?: string;
    postReaction?: string;
    name?: string;
}

export type SearchAppButtonType = 'GoToSite' | 'BuyOnSite' | 'Catalog';

interface SearchAppGoalInformation extends GoalInformation {
    product_id?: string;
    post_id?: string;
    business_id?: string;
    button_type?: SearchAppButtonType;
    clickout_url?: string;
    source?: 'business_catalog_page' | 'post_products_page';
}

export const trackGoal = (event: Goals, params?: GoalInformation) => {
    if (process.env.REACT_APP_METRIC) {
        window.ym(process.env.REACT_APP_METRIC, 'reachGoal', event, params);
    }
};

// Базовые цели

export const ymTrackPostLike = (params?: GoalInformation) => {
    trackGoal(Goals.ANY_LIKE, params);
};

export const ymTrackPostDislike = (params?: GoalInformation) => {
    trackGoal(Goals.ANY_DISLIKE, params);
};

export const ymTrackPostBookmark = (params?: GoalInformation) => {
    trackGoal(Goals.ANY_FAVOURITE, params);
};

export const ymTrackSubscribe = (params?: GoalInformation) => {
    trackGoal(Goals.ANY_SUBSCRIBE, params);
};

export const ymTrackClickout = (params?: GoalInformation) => {
    trackGoal(Goals.ANY_CLICKOUT, params);
};

export const ymTrackPostShare = (params?: GoalInformation) => {
    trackGoal(Goals.ANY_POST_SHARE, params);
};

export const ymTrackPostExpand = (params?: GoalInformation) => {
    trackGoal(Goals.ANY_DESCRIPTION_OPEN, params);
};

export const ymTrackFeedScroll = (params?: GoalInformation) => {
    trackGoal(Goals.FEED_SCROLL, params);
};

export const ymTrackPostStatusClick = (params?: GoalInformation) => {
    trackGoal(Goals.POST_STATUS_CLICK, params);
};

// Цели на странице регистрации

export const ymTrackGoToRegistration = (params?: GoalInformation) => {
    trackGoal(Goals.REGISTRATION_WANTED, params);
};

const ymTrackSiteFilled = (params?: GoalInformation) => {
    trackGoal(Goals.REGISTRATION_SITE_FILLED, params);
};

const ymTrackInstagramFilled = (params?: GoalInformation) => {
    trackGoal(Goals.REGISTRATION_INSTAGRAM_FILLED, params);
};

const ymTrackTelegramFilled = (params?: GoalInformation) => {
    trackGoal(Goals.REGISTRATION_TELEGRAM_FILLED, params);
};

const ymTrackBusinessNameFilled = (params?: GoalInformation) => {
    trackGoal(Goals.REGISTRATION_BUSINESS_NAME_FILLED, params);
};

const ymTrackOfferChecked = (params?: GoalInformation) => {
    trackGoal(Goals.REGISTRATION_OFFER_CHECKED, params);
};

const ymTrackAgreedLettersChecked = (params?: GoalInformation) => {
    trackGoal(Goals.REGISTRATION_AGREED_LETTERS_CHECKED, params);
};

export const trackFieldFilled = (fieldName: string, params?: GoalInformation) => {
    if (fieldName === 'domain') {
        ymTrackSiteFilled(params);
    } else if (fieldName === 'instagramUrl') {
        ymTrackInstagramFilled(params);
    } else if (fieldName === 'telegramUrl') {
        ymTrackTelegramFilled(params);
    } else if (fieldName === 'displayName') {
        ymTrackBusinessNameFilled(params);
    } else if (fieldName === 'offerAgreement') {
        ymTrackOfferChecked(params);
    } else if (fieldName === 'sendAdMails') {
        ymTrackAgreedLettersChecked(params);
    }
};

export const ymTrackSubmitRegistration = (params?: GoalInformation) => {
    trackGoal(Goals.SUBMIT_REGISTRATION, params);
};

export const ymTrackOfferAgreement = (params?: GoalInformation) => {
    trackGoal(Goals.OFFER_ACCEPTED, params);
};

// Метрики на странице Профиля бизнеса

export const ymTrackChangeCover = (params?: GoalInformation) => {
    trackGoal(Goals.CHANGE_COVER, params);
};

export const ymTrackSaveCover = (params?: GoalInformation) => {
    trackGoal(Goals.SAVE_COVER, params);
};

export const ymTrackSaveCoverError = (params?: GoalInformation) => {
    trackGoal(Goals.COVER_CHANGE_ERROR, params);
};

export const ymTrackChangeAvatar = (params?: GoalInformation) => {
    trackGoal(Goals.CHANGE_AVATAR, params);
};

export const ymTrackSaveAvatar = (params?: GoalInformation) => {
    trackGoal(Goals.SAVE_AVATAR, params);
};

export const ymTrackSaveAvatarError = (params?: GoalInformation) => {
    trackGoal(Goals.AVATAR_CHANGE_ERROR, params);
};

export const ymTrackSettingsClick = (params?: GoalInformation) => {
    trackGoal(Goals.GO_TO_SETTINGS, params);
};

export const ymTrackPublishedClick = (params?: GoalInformation) => {
    trackGoal(Goals.PUBLISHED_TAB_CLICK, params);
};

export const ymTrackAllPostClick = (params?: GoalInformation) => {
    trackGoal(Goals.ALL_POST_TAB_CLICK, params);
};

export const ymTrackProfilePostClick = (params?: GoalInformation) => {
    trackGoal(Goals.PROFILE_POST_CLICK, params);
};

export const ymTrackPostKebabClick = (params?: GoalInformation) => {
    trackGoal(Goals.POST_KEBAB_CLICK, params);
};

export const ymTrackChatClick = (params?: GoalInformation) => {
    trackGoal(Goals.CHAT, params);
};

export const ymTrackStatisticsClick = (params?: GoalInformation) => {
    trackGoal(Goals.STATISTIC_CLICK, params);
};

export const ymTrackPostEditClick = (params?: GoalInformation) => {
    trackGoal(Goals.POST_EDIT_CLICK, params);
};

export const ymTrackPostDeleteClick = (params?: GoalInformation) => {
    trackGoal(Goals.POST_DELETE_CLICK, params);
};

export const ymTrackOpenCatalogFromBusiness = (params?: GoalInformation) => {
    trackGoal(Goals.BUSINESS_CATALOG_CLICK, params);
};

// Цели настройки бизнеса

export const ymTrackGoToSupport = (params?: GoalInformation) => {
    trackGoal(Goals.GO_TO_SUPPORT, params);
};
const ymTrackSettingsNameFilled = (params?: GoalInformation) => {
    trackGoal(Goals.SETTINGS_NAME_FILLED, params);
};
const ymTrackSettingsDescriptionFilled = (params?: GoalInformation) => {
    trackGoal(Goals.SETTINGS_DESCRIPTION_FILLED, params);
};
const ymTrackSettingsSiteFilled = (params?: GoalInformation) => {
    trackGoal(Goals.SETTINGS_SITE_FILLED, params);
};
const ymTrackSettingsHideInFeed = (params?: GoalInformation) => {
    trackGoal(Goals.SETTINGS_HIDE_PROFILE, params);
};
const ymTrackSettingsImportPublished = (params?: GoalInformation) => {
    trackGoal(Goals.SETTINGS_IMPORT_PUBLISHED, params);
};
const ymTrackSettingsImportDraft = (params?: GoalInformation) => {
    trackGoal(Goals.SETTINGS_IMPORT_DRAFT, params);
};
const ymTrackSettingsDoNotImport = (params?: GoalInformation) => {
    trackGoal(Goals.SETTINGS_DO_NOT_IMPORT, params);
};

export const ymTrackSettingsRemoveAdmin = (params?: GoalInformation) => {
    trackGoal(Goals.SETTINGS_REMOVE_USER, params);
};

export const ymTrackSettingsCreateInvite = (params?: GoalInformation) => {
    trackGoal(Goals.SETTINGS_CREATE_INVITE, params);
};

export const ymTrackSettingsCopyInvite = (params?: GoalInformation) => {
    trackGoal(Goals.SETTINGS_COPY_INVITE, params);
};

export const ymTrackSettingsProfileSave = (params?: GoalInformation) => {
    trackGoal(Goals.SETTINGS_SAVE, params);
};

export const ymTrackSettingsRemoveBusiness = (params?: GoalInformation) => {
    trackGoal(Goals.SETTINGS_REMOVE_BUSINESS, params);
};

export const trackSettingsFieldFilled = (fieldName: string, params?: GoalInformation) => {
    if (fieldName === 'displayName') {
        ymTrackSettingsNameFilled(params);
    } else if (fieldName === 'description') {
        ymTrackSettingsDescriptionFilled(params);
    } else if (fieldName === 'links.siteDisplay') {
        ymTrackSettingsSiteFilled(params);
    } else if (fieldName === 'hideInFeed') {
        ymTrackSettingsHideInFeed(params);
    } else if (fieldName === 'import_publish') {
        ymTrackSettingsImportPublished(params);
    } else if (fieldName === 'import_draft') {
        ymTrackSettingsImportDraft(params);
    } else if (fieldName === 'do_not_import') {
        ymTrackSettingsDoNotImport(params);
    }
};

// Цели редактирование/создание поста

export const ymTrackEditPostPreview = (params?: GoalInformation) => {
    trackGoal(Goals.EDIT_POST_PREVIEW, params);
};

export const ymTrackEditPostGetDraft = (params?: GoalInformation) => {
    trackGoal(Goals.EDIT_POST_GET_DRAFT, params);
};

export const ymTrackEditPostSaveDraft = (params?: GoalInformation) => {
    trackGoal(Goals.EDIT_POST_SAVE_DRAFT, params);
};

export const ymTrackEditPostPublish = (params?: GoalInformation) => {
    trackGoal(Goals.EDIT_POST_REPUBLISH, params);
};

export const ymTrackEditPostDelete = (params?: GoalInformation) => {
    trackGoal(Goals.EDIT_POST_DELETE, params);
};

export const ymTrackEditPostDescriptionFilled = (params?: GoalInformation) => {
    trackGoal(Goals.EDIT_POST_DESCRIPTION_FILLED, params);
};

export const ymTrackEditPostLinkFilled = (params?: GoalInformation) => {
    trackGoal(Goals.EDIT_POST_LINK_FILLED, params);
};

export const trackEditPostFieldFilled = (fieldName: string, params?: GoalInformation) => {
    if (fieldName === 'text') {
        ymTrackEditPostDescriptionFilled(params);
    } else if (fieldName === 'site') {
        ymTrackEditPostLinkFilled(params);
    }
};

// Цели управления лентой

export const ymTrackFeedManager = (params?: GoalInformation) => {
    trackGoal(Goals.FEED_MANAGER, params);
};

const ymTrackFeedManagerStatus = (params?: GoalInformation) => {
    trackGoal(Goals.FEED_MANAGER_STATUS, params);
};

const ymTrackFeedManagerSource = (params?: GoalInformation) => {
    trackGoal(Goals.FEED_MANAGER_SOURCE, params);
};

const ymTrackFeedManagerPeriod = (params?: GoalInformation) => {
    trackGoal(Goals.FEED_MANAGER_PERIOD, params);
};

export const ymTrackFeedManagerChangeFiltersParams = (name: string, params?: GoalInformation) => {
    if (name === 'source') {
        ymTrackFeedManagerSource(params);
    }
    if (name === 'status') {
        ymTrackFeedManagerStatus(params);
    }

    if (name === 'period') {
        ymTrackFeedManagerPeriod(params);
    }
};

export const ymTrackFeedManagerSelectPost = (params?: GoalInformation) => {
    trackGoal(Goals.FEED_MANAGER_SELECT_POST, params);
};

const ymTrackFeedManagerDeletePost = (params?: GoalInformation) => {
    trackGoal(Goals.FEED_MANAGER_DELETE_POST, params);
};

export const ymTrackFeedManagerPublishPost = (params?: GoalInformation) => {
    trackGoal(Goals.FEED_MANAGER_PUBLISH_POST, params);
};

export const ymTrackFeedManagerBulkChangeStatus = (status: string, params?: GoalInformation) => {
    if (status === PostStatus.DELETED) {
        ymTrackFeedManagerDeletePost(params);
    }
    if (status === PostStatus.PUBLISHED) {
        ymTrackFeedManagerPublishPost(params);
    }
};

export const ymTrackFeedManagerStaticOpen = (params?: GoalInformation) => {
    trackGoal(Goals.FEED_MANAGER_STATISTIC, params);
};

export const ymTrackFeedManagerPostsOpen = (params?: GoalInformation) => {
    trackGoal(Goals.FEED_MANAGER_POSTS, params);
};

// Цели на странице поиска

export const ymTrackSearchOpen = (params?: GoalInformation) => {
    trackGoal(Goals.SEARCH_OPEN, params);
};

export const ymTrackSearchInputFocusOut = (params?: GoalInformation) => {
    trackGoal(Goals.SEARCH_INPUT_FOCUS_OUT, params);
};

export const ymTrackSwitchSearchType = (params?: GoalInformation) => {
    trackGoal(Goals.SWITCH_SEARCH_TYPE, params);
};

export const ymTrackSearchGoToPost = (params?: GoalInformation) => {
    trackGoal(Goals.SEARCH_GO_TO_POST, params);
};

export const ymTrackSearchGoToBusiness = (params?: GoalInformation) => {
    trackGoal(Goals.SEARCH_GO_TO_BUSINESS, params);
};

export const ymTrackSearchInputStart = (params?: GoalInformation) => {
    trackGoal(Goals.SEARCH_INPUT_START, params);
};

// Цели товаров

export const ymTrackSwitchProductsAutoImport = (params?: GoalInformation) => {
    trackGoal(Goals.SWITCH_PRODUCTS_AUTO_IMPORT, params);
};

export const ymTrackSwitchProductsAutoParser = (params?: GoalInformation) => {
    trackGoal(Goals.SWITCH_PRODUCTS_AUTO_PARSER, params);
};

export const ymTrackRemoveProductFromPost = (params?: GoalInformation) => {
    trackGoal(Goals.REMOVE_PRODUCT_FROM_POST, params);
};

export const ymTrackProductsUnroll = (params?: GoalInformation) => {
    trackGoal(Goals.PRODUCTS_UNROLL, params);
};

export const ymTrackProductClickOut = (params?: GoalInformation) => {
    trackGoal(Goals.PRODUCT_CLICK_OUT, params);
};

export const ymTrackMoreProductsClickOut = (params?: GoalInformation) => {
    trackGoal(Goals.MORE_PRODUCTS_CLICK_OUT, params);
};

export const ymTrackProductNotFound = (params?: GoalInformation) => {
    trackGoal(Goals.PRODUCT_NOT_FOUND, params);
};

export const ymTrackProductsCatalogClick = (params?: GoalInformation) => {
    trackGoal(Goals.PRODUCTS_CATALOG_CLICK, params);
};

// Цели коллекций

export const ymTrackOpenCollectionLink = (params?: GoalInformation) => {
    trackGoal(Goals.OPEN_COLLECTION_LINK, params);
};

export const ymTrackOpenCollectionFromProfile = (params?: GoalInformation) => {
    trackGoal(Goals.OPEN_COLLECTION_FROM_PROFILE, params);
};

export const ymTrackOpenCollectionLike = (params?: GoalInformation) => {
    trackGoal(Goals.COLLECTION_LIKE, params);
};

export const ymTrackOpenCollectionShared = (params?: GoalInformation) => {
    trackGoal(Goals.COLLECTION_SHARED, params);
};

export const ymTrackCollectionEdit = (params?: GoalInformation) => {
    trackGoal(Goals.COLLECTION_EDIT, params);
};

export const ymTrackCollectionReport = (params?: GoalInformation) => {
    trackGoal(Goals.COLLECTION_REPORT, params);
};

export const ymTrackContextMenuOpen = (params?: GoalInformation) => {
    trackGoal(Goals.CONTEXT_MENU_OPEN, params);
};

export const ymTrackCollectionGetProductFromUrlOpenDialog = (params?: GoalInformation) => {
    trackGoal(Goals.COLLECTION_GET_PRODUCT_FROM_URL_OPEN_DIALOG, params);
};

export const ymTrackCollectionGetProductFromUrlCloseDialog = (params?: GoalInformation) => {
    trackGoal(Goals.COLLECTION_GET_PRODUCT_FROM_URL_CLOSE_DIALOG, params);
};

export const ymTrackCollectionGetProductFromUrlSubmit = (params?: GoalInformation) => {
    trackGoal(Goals.COLLECTION_GET_PRODUCT_FROM_URL_SUBMIT, params);
};

export const ymTrackCollectionGetProductFromUrlError = (params?: GoalInformation) => {
    trackGoal(Goals.COLLECTION_GET_PRODUCT_FROM_URL_ERROR, params);
};

export const ymTrackCollectionAddProductPostCloseDialog = (params?: GoalInformation) => {
    trackGoal(Goals.COLLECTION_ADD_PRODUCT_POST_CLOSE_DIALOG, params);
};

export const ymTrackCollectionAddProductPostSubmit = (params?: GoalInformation) => {
    trackGoal(Goals.COLLECTION_ADD_PRODUCT_POST_SUBMIT, params);
};

export const ymTrackCollectionAddProductPostRemoveImage = (params?: GoalInformation) => {
    trackGoal(Goals.COLLECTION_ADD_PRODUCT_POST_REMOVE_IMAGE, params);
};

export const ymTrackServiceRulesClick = (params?: GoalInformation) => {
    trackGoal(Goals.SERVICE_RULES_LINK_CLICK, params);
};

export const ymTrackSupportClick = (params?: GoalInformation) => {
    trackGoal(Goals.SUPPORT_LINK_CLICK, params);
};

export const ymTrackSawFifthClick = (params?: GoalInformation) => {
    trackGoal(Goals.SAW_FIFTH_POST, params);
};

export const ymTrackSawTenthClick = (params?: GoalInformation) => {
    trackGoal(Goals.SAW_TENTH_POST, params);
};

export const ymTrackSawFifteenthClick = (params?: GoalInformation) => {
    trackGoal(Goals.SAW_FIFTEENTH_POST, params);
};

export const ymTrackClickToInstall = (params?: GoalInformation) => {
    trackGoal(Goals.CLICK_TO_INSTALL, params);
};

// Цели в постовой гриде

export const ymTrackPostInGridClick = (params?: GoalInformation) => {
    trackGoal(Goals.POST_IN_GRID_CLICK, params);
};

export const ymTrackPostInGridRowShown = (params?: GoalInformation) => {
    trackGoal(Goals.POST_IN_GRID_ROW_SHOWN, params);
};

export const ymTrackPostInGridScroll = (params?: GoalInformation) => {
    trackGoal(Goals.POST_IN_GRID_FEED_SCROLL, params);
};

export const ymTrackPostInGridBusinessClick = (params?: GoalInformation) => {
    trackGoal(Goals.POST_IN_GRID_BUSINESS_CLICK, params);
};

export const ymTrackPostInGridKebabClick = (params?: GoalInformation) => {
    trackGoal(Goals.POST_IN_GRID_KEBAB_CLICK, params);
};

export const ymTrackPostInGridKebabShare = (params?: GoalInformation) => {
    trackGoal(Goals.POST_IN_GRID_KEBAB_SHARE, params);
};

export const ymTrackPostInGridKebabBusinessClick = (params?: GoalInformation) => {
    trackGoal(Goals.POST_IN_GRID_KEBAB_BUSINESS_CLICK, params);
};

export const ymTrackPostInGridKebabReport = (params?: GoalInformation) => {
    trackGoal(Goals.POST_IN_GRID_KEBAB_REPORT, params);
};

export const ymTrackPostInGridVideoPlay = (params?: GoalInformation) => {
    trackGoal(Goals.POST_IN_GRID_VIDEO_PLAY, params);
};

// Цели в товарном каталоге

export const ymTrackProductInCatalogClickout = (params?: GoalInformation) => {
    trackGoal(Goals.PRODUCT_IN_CATALOG_CLICKOUT, params);
};

export const ymTrackProductCatalogClickout = (params?: GoalInformation) => {
    trackGoal(Goals.PRODUCT_CATALOG_CLICKOUT, params);
};

// Цели постовой страницы

export const ymTrackOpenCatalogFromPost = (params?: GoalInformation) => {
    trackGoal(Goals.POST_CATALOG_CLICK, params);
};

// Цели страницы товаров в ПП

export const ymTrackFeedCurtainShown = (params?: SearchAppGoalInformation) => {
    trackGoal(Goals.FEED_CURTAIN_SHOWN, params);
};

export const ymTrackFeedCurtainButtonShown = (params?: SearchAppGoalInformation) => {
    trackGoal(Goals.FEED_CURTAIN_BUTTON_SHOWN, params);
};

export const ymTrackFeedCurtainButtonClick = (params?: SearchAppGoalInformation) => {
    trackGoal(Goals.FEED_CURTAIN_BUTTON_CLICK, params);
};

export const ymTrackFeedCurtainProductShown = (params?: SearchAppGoalInformation) => {
    trackGoal(Goals.FEED_CURTAIN_PRODUCT_SHOWN, params);
};

export const ymTrackFeedCurtainProductClick = (params?: SearchAppGoalInformation) => {
    trackGoal(Goals.FEED_CURTAIN_PRODUCT_CLICK, params);
};
